function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/logistics/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const logisticsRoutes = [
  {
    path: '/logistics/dashboard',
    component: view('Dashboard'),
    name: 'logistics.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics/sales-order',
    component: view('SalesOrder'),
    name: 'logistics.sales-order',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order',
          active: true
        }
      ]
    }
  },
  {
    path: '/logistics/sales-order-tracker/:status?',
    component: view('SalesOrderTracker'),
    name: 'logistics.sales-order-tracker',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Sales Order Tracker',
          active: true
        }
      ]
    }
  }
]

export default logisticsRoutes
